<!--党建引领-->
<template>
    <div class="studio_nav_content">
        <div class="content-container1" v-show="showMode==='page'">
            <!-- 思想理论 -->
            <div class="section-card">
                <div class="title-container">
                    <a class="a-link">思想理论</a>
                    <a class="more-link" @click="pageDangJian('思想理论','1')">更多</a>
                </div>
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.llsxList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.llsxList&&homeData.llsxList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 党章党规 -->
            <div class="section-card">
                <div class="title-container">
                    <a class="a-link">党章党规</a>
                    <a class="more-link" @click="pageDangJian('党章党规','2')">更多</a>
                </div>
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.dzdgList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.dzdgList&&homeData.dzdgList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 文件汇编 -->
            <div class="section-card">
                <div class="title-container">
                    <a class="a-link">文件汇编</a>
                    <a class="more-link" @click="pageDangJian('文件汇编','3')">更多</a>
                </div>
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.wjhbList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.wjhbList&&homeData.wjhbList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 支部生活 -->
            <div class="section-card">
                <div class="title-container">
                    <a class="a-link">支部生活</a>
                    <a class="more-link" @click="pageDangJian('支部生活','4')">更多</a>
                </div>
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.zbshList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.zbshList&&homeData.zbshList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <page-dangj :info-mode="infoMode" :title="title" :dj-type="category"
                        @change-mode="changeModel" />
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detailInfo'">
            <div class="dj-container">
                <div class="head-container">
                    <div class="left-head-container" @click="changeModel('page')">
                        <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="right-head-container">{{ form.title }}</div>
                    <div class="left-head-container">
                    </div>
                </div>
                <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageDangj from "@/components/resourceCentre/pageDangj.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {homeDangjNew, infoDangj} from "@/api/admin/dangj"

export default {
    name:'djylResourceNew',
    components:{dataEmpty,pageDangj},
    props:{
        courseMode:{
            type: String,
            default:'page',
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
    },
    created() {
        this.queryHomeData();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            homeData:{},
            title:'',
            subTitle:'',
            category:'',
            infoMode:"pageSub",
            dangjId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        queryHomeData(){
            homeDangjNew().then(res=>{
                if (res.data.code === 1) {
                    this.homeData = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        pageDangJian(t,c){
            this.title = t;
            this.category = c;
            this.showMode = 'detail';
            this.infoMode = this.infoMode+new Date();
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        viewDangj(item){
            this.dangjId = item.dangjId;
            this.getDangjInfo();
            this.showMode = "detailInfo"
            this.$emit('change-mode',this.showMode);
        },
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
}

</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.content-container1{
    width: 100%;
    height: auto;
}
/*板块白色卡片，内容超出时页面自然滚动*/
.section-card{
    background: #ffffff;
    border-radius: 16px;
    padding: 18px 24px 12px;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.title-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #e3ecf7;
    margin-bottom: 12px;
}
.a-link{
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
    border-bottom: 2px solid #ff7f2e;
    padding-bottom: 8px;
    margin-bottom: -1px;
    text-decoration: none;
}
.more-link{
    font-size: 15px;
    color: #8a97a8;
    padding-bottom: 8px;
    text-decoration: none;
    cursor: pointer;
}
.more-link:hover{
    color: #ff7f2e;
}
/*条目三列布局*/
.item-container{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.item-one{
    width: 33.33%;
    display: flex;
    box-sizing: border-box;
    padding-right: 16px;
}
.dj-item-l{
    width: 12px;
    height: 40px;
    flex-shrink: 0;
}
.dj-yuan{
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #ff7f2e;
    margin-top: 12px;
}
.dj-item-r{
    width: calc(100% - 12px);
    height: 40px;
    color: #595758;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    padding-top: 3px;
    box-sizing: border-box;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.dj-item-r:hover{
    color: #ff7f2e;
}
.div-100{
    width: 100%;
}

/*列表页（更多）白色卡片*/
.content-container{
    width: 100%;
    height: auto;
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    box-sizing: border-box;
}

/*详情页白色卡片*/
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 28px 30px;
    box-sizing: border-box;
}
.dj-time{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 100%;
    overflow-x: hidden;
}
.dj-content /deep/ img{
    max-width: 100%;
}

.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-top: 8px;
    box-sizing: border-box;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
</style>
